const prefix = 'nxt';
const iconName = 'devices';
const width = 16;
const height = 12;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M2.66667 2.6665C2.66667 2.29984 2.96667 1.99984 3.33333 1.99984H14C14.3667 1.99984 14.6667 1.69984 14.6667 1.33317C14.6667 0.966504 14.3667 0.666504 14 0.666504H2.66667C1.93333 0.666504 1.33333 1.2665 1.33333 1.99984V9.33317H1C0.446667 9.33317 0 9.77984 0 10.3332C0 10.8865 0.446667 11.3332 1 11.3332H9.33333V9.33317H2.66667V2.6665ZM15.3333 3.33317H11.3333C10.9667 3.33317 10.6667 3.63317 10.6667 3.99984V10.6665C10.6667 11.0332 10.9667 11.3332 11.3333 11.3332H15.3333C15.7 11.3332 16 11.0332 16 10.6665V3.99984C16 3.63317 15.7 3.33317 15.3333 3.33317ZM14.6667 9.33317H12V4.6665H14.6667V9.33317Z',
];

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtDevices = definition;

export { definition, nxtDevices, prefix, iconName, width, height, ligatures, unicode, svgPathData };
